/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateDealAccountOwnersQueryResponse,
  ValidateDealAccountOwnersPathParams,
  ValidateDealAccountOwners404,
  ValidateDealAccountOwners422,
} from '../types/ValidateDealAccountOwners'

function getValidateDealAccountOwnersUrl({
  import_number,
}: {
  import_number: ValidateDealAccountOwnersPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/validate-deal-account-owners/` as const,
  }
  return res
}

/**
 * @summary Validate deal account-owner emails against company users
 * {@link /api/v1/importengine/previews/v2/:import_number/validate-deal-account-owners/}
 */
export async function validateDealAccountOwners(
  {
    import_number,
  }: { import_number: ValidateDealAccountOwnersPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ValidateDealAccountOwnersQueryResponse,
    ResponseErrorConfig<
      ValidateDealAccountOwners404 | ValidateDealAccountOwners422
    >,
    unknown
  >({
    method: 'GET',
    url: getValidateDealAccountOwnersUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
